const services = [
  {
    tag: '服務 01',
    title: '專業復康外展服務',
    subtitle: '穩定、合規的跨專業治療團隊',
    description:
      '由持牌物理治療師、職業治療師及言語治療師組成的跨專業團隊，為院舍提供全面的復康外展服務，涵蓋甲一級買位院舍及NGO的專業復康訓練。',
    image:
      'https://public.readdy.ai/ai/img_res/edited_03d3c7b8914333275c6e4d1b1de8d081_5cd8765e.jpg',
    imagePosition: 'left',
    detailLink: '/services/rehabilitation-outreach',
    details: [
      {
        icon: 'ri-walk-line',
        name: '物理治療',
        desc: '步態訓練、肌力強化、痛症管理、跌倒預防及術後復康',
      },
      {
        icon: 'ri-hand-line',
        name: '職業治療',
        desc: '日常生活能力訓練、認知訓練、輔助器具評估及家居改裝建議',
      },
      {
        icon: 'ri-chat-voice-line',
        name: '言語治療',
        desc: '吞嚥功能評估與訓練、溝通能力訓練、失語症復康',
      },
    ],
    pricing: [
      { plan: '基礎計劃', price: '每月 $8,800 起', note: '每週 2 次到診' },
      { plan: '標準計劃', price: '每月 $15,800 起', note: '每週 4 次到診' },
      { plan: '全面計劃', price: '每月 $24,800 起', note: '每週 6 次到診' },
    ],
  },
  {
    tag: '服務 02',
    title: '復康訓練器材及監測系統',
    subtitle: '助您善用資源，實現智慧護理',
    description:
      '供應專業復康訓練器材及智能監測系統，並提供一站式顧問服務，配合樂齡及康復創科應用基金等資助。從方案策劃、產品選配到項目執行，全程為您護航。',
    image:
      'https://public.readdy.ai/ai/img_res/71902fba505e9b6fea09e5c5a1156a72.jpg',
    imagePosition: 'right',
    detailLink: '/services/equipment-monitoring',
    details: [
      {
        icon: 'ri-robot-line',
        name: '智能復康器材',
        desc: '上下肢訓練機、平衡訓練系統、電療儀器及超聲波治療設備',
      },
      {
        icon: 'ri-heart-pulse-line',
        name: '智能監測系統',
        desc: '24小時生命體徵監測、跌倒偵測感應器、智能床墊壓力監測',
      },
      {
        icon: 'ri-file-list-3-line',
        name: '資助申請顧問',
        desc: '協助申請樂齡科技基金、康復創科應用基金，最高資助達 $500,000',
      },
    ],
    pricing: [
      { plan: '器材租賃', price: '每月 $3,500 起', note: '含定期維護保養' },
      { plan: '器材購置', price: '一次性報價', note: '含安裝及培訓' },
      { plan: '顧問服務', price: '按項目報價', note: '資助申請成功收費' },
    ],
  },
  {
    tag: '服務 03',
    title: '院舍改善工程',
    subtitle: '打造合規、安全、舒適的現代化院舍',
    description:
      '針對政府提升院舍人均面積及設施標準的新規定，我們的專業工程團隊提供從空間規劃、設計繪圖、牌照顧問到工程施工的全方位服務，助您順利完成院舍升級。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20renovated%20Hong%20Kong%20elderly%20care%20home%20interior%20with%20wide%20accessible%20corridors%2C%20bright%20spacious%20rooms%2C%20Chinese%20elderly%20residents%20and%20Chinese%20nursing%20staff%2C%20warm%20wood%20tones%2C%20clean%20professional%20healthcare%20facility%2C%20soft%20natural%20lighting%2C%20East%20Asian%20people%2C%20realistic%20interior%20photography&width=600&height=480&seq=hk_service3_v2&orientation=portrait',
    imagePosition: 'left',
    detailLink: '/services/renovation',
    details: [
      {
        icon: 'ri-layout-line',
        name: '空間規劃設計',
        desc: '符合社署最新人均面積標準，優化動線設計，提升院友生活質素',
      },
      {
        icon: 'ri-government-line',
        name: '牌照顧問服務',
        desc: '全程跟進社署審批程序，確保工程符合《安老院條例》各項規定',
      },
      {
        icon: 'ri-tools-line',
        name: '工程施工管理',
        desc: '無障礙設施安裝、防滑地板、扶手欄杆、緊急召喚系統等全面翻新',
      },
    ],
    pricing: [
      { plan: '顧問評估', price: '$5,000 起', note: '現場勘察及報告' },
      { plan: '設計方案', price: '$15,000 起', note: '含平面圖及3D效果圖' },
      { plan: '全包工程', price: '按面積報價', note: '設計施工一條龍' },
    ],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-orange-50/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 bg-orange-500 rounded-full mb-6">
            <span className="text-sm font-bold text-white tracking-wider">我們的服務</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            全方位院舍解決方案
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-orange-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            深諳院舍營運的各種挑戰，我們透過三大核心業務，為私營院舍、NGO及長者日間中心提供前瞻性、全方位的解決方案
          </p>
        </div>

        {/* Services List */}
        <div className="space-y-32">
          {services.map((service, index) => (
            <div
              id={`service-${index}`}
              key={index}
              className={`flex flex-col ${
                service.imagePosition === 'right' ? 'lg:flex-row-reverse' : 'lg:flex-row'
              } gap-14 items-start`}
            >
              {/* Image */}
              <div className="w-full lg:w-5/12 flex-shrink-0">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
                  <div className="w-full h-[480px]">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                  <div className="absolute top-5 left-5">
                    <span className="bg-orange-500 text-white text-xs font-bold px-4 py-2 rounded-full">
                      {service.tag}
                    </span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-7/12 space-y-6">
                <div>
                  <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-orange-500 font-semibold text-lg mb-4">{service.subtitle}</p>
                  <p className="text-slate-600 leading-relaxed text-base">{service.description}</p>
                </div>

                {/* Detail Items */}
                <div className="space-y-3">
                  {service.details.map((d, i) => (
                    <div
                      key={i}
                      className="flex items-start gap-4 bg-white rounded-xl p-4 shadow-sm border border-orange-100 hover:border-orange-300 hover:shadow-md transition-all duration-300"
                    >
                      <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-lg flex-shrink-0">
                        <i className={`${d.icon} text-xl text-orange-500`}></i>
                      </div>
                      <div>
                        <p className="font-bold text-slate-800 text-sm mb-1">{d.name}</p>
                        <p className="text-slate-500 text-sm leading-relaxed">{d.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pricing */}
                <div className="bg-gradient-to-br from-orange-50 to-orange-100/60 rounded-2xl p-6 border border-orange-200">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-price-tag-3-line text-orange-500 text-lg"></i>
                    </div>
                    <h4 className="font-bold text-slate-800 text-base">收費參考</h4>
                    <span className="text-xs text-slate-400 ml-1">（實際收費按需求而定）</span>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {service.pricing.map((p, i) => (
                      <div
                        key={i}
                        className="bg-white rounded-xl p-4 text-center shadow-sm border border-orange-100 hover:shadow-md transition-all duration-300"
                      >
                        <p className="text-xs font-semibold text-orange-500 mb-1 uppercase tracking-wide">
                          {p.plan}
                        </p>
                        <p className="text-lg font-bold text-slate-900 mb-1">{p.price}</p>
                        <p className="text-xs text-slate-400">{p.note}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-wrap gap-4">
                  <a
                    href={service.detailLink}
                    className="inline-flex items-center border-2 border-orange-500 text-orange-500 font-bold px-8 py-4 rounded-full hover:bg-orange-50 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
                  >
                    <span>了解更多</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                  <a
                    href="/contact"
                    className="inline-flex items-center bg-orange-500 text-white font-bold px-8 py-4 rounded-full hover:bg-orange-600 transition-all duration-300 hover:shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    <span>立即查詢報價</span>
                    <i className="ri-mail-line ml-2"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Banner */}
        <div className="mt-28 bg-gradient-to-r from-orange-500 to-orange-600 rounded-3xl p-12 text-center shadow-xl">
          <h3 className="text-3xl font-bold text-white mb-3">需要度身訂造的方案？</h3>
          <p className="text-orange-100 text-lg mb-8 max-w-xl mx-auto">
            我們的專業顧問團隊將為您的院舍提供免費評估，制定最適合的服務組合
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center bg-white text-orange-600 font-bold px-8 py-4 rounded-full hover:bg-orange-50 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              預約免費諮詢
            </a>
            <a
              href="tel:+85224015938"
              className="inline-flex items-center justify-center border-2 border-white text-white font-bold px-8 py-4 rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              2401 5938
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}